import { render, staticRenderFns } from "./ShareOpportunityDialog.vue?vue&type=template&id=12e55304"
import script from "./ShareOpportunityDialog.vue?vue&type=script&lang=js"
export * from "./ShareOpportunityDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareOpportunityDialog.vue?vue&type=style&index=0&id=12e55304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports